<app-input-select
  idField="idAto"
  labelField="ato"
  [list]="areraAto"
  [name]="name"
  label="ARERA Ato"
  icon="stars"
  [form]="form"
  [searchComponentTemplate]="searchTemplate"
></app-input-select>
